import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../common/base.component';
import { CommonConfig } from '../../../configs/common.config';

@Component({
  selector: 'merge-timepicker',
  templateUrl: './merge-timepicker.component.html',
  styleUrls: ['./merge-timepicker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MergeTimepickerComponent extends BaseComponent implements ControlValueAccessor {

  /** label */
  @Input() label: string;
  /** required */
  @Input() isRequired: boolean;
  /** disabled */
  @Input() set isDisabled(val: boolean) {
    this.disabled = val;
  }
  /** set 12/24 format (24 if false) */
  @Input() showMeridian: boolean = true;
  /** set step for minutes */
  @Input() minuteStep = 15;
  /** set errorMessage */
  @Input() errorMessage: string;
  /** set isError state */
  @Input() isError: boolean;
  /** set placeholder */
  @Input() placeholder: string = CommonConfig.datesFormat.timePlaceholder;
  @Output() timeChanged = new EventEmitter<Date>();

  set value(val: Date) {
    this._value = val;
    this.change(val);
  }

  get value(): Date {
    return this._value;
  }

  get control(): AbstractControl {
    return this.ngControl.control;
  }

  constructor(private ngControl: NgControl, private cdRef: ChangeDetectorRef, @Optional() private parentForm: FormGroupDirective) {
    super();
    ngControl.valueAccessor = this;
    this.handleOnSubmit();
  }

  _value: Date;
  disabled: boolean;

  showTimepicker = false;

  change(value: Date): void {
    this.onChange(value);
    this.onTouch();
    this.cdRef.detectChanges();
  }

  onChange: any = () => { };
  onTouch: any = () => { };

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.showTimepicker = !this.showTimepicker;
    }
  }

  closeTimePicker(): void {
    if (this.showTimepicker) {
      this.showTimepicker = false;
      if (!this.control.touched) {
        this.onTouch();
      }
    }
  }

  registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdRef.detectChanges();
  }

  writeValue(value: Date): void {
    this._value = value;
    if (!this.cdRef['destroyed']) {
      this.cdRef.detectChanges();
    }
  }

  private handleOnSubmit(): void {
    if (this.parentForm) {
      this.parentForm.ngSubmit.pipe(takeUntil(this.destroy$)).subscribe((_) => {
        this.onTouch();
        this.cdRef.detectChanges();
      });
    }
  }

  onValueChanged(event: Date): void {
    if (this._value !== event) {
      this._value = event;
      this.control.setValue(event);
      this.timeChanged.emit(event);
    }
      this.control.markAsTouched();
      this.control.markAsDirty();
  }

}
